<template>
  <div>
    <h1 class="title mqu-subtitle">
      Ongoing/Recurrent Fees
    </h1>
    <h2 class="subtitle">
      In most retirement village contracts the resident will have to pay <b-tooltip label="These fees may be called maintenance fee, rent, strata levy, retirement village levy or some other term. For some villages, you might need to include council rates, water rates, etc." :multilined="true" :animated="true" position="is-bottom" type="is-warning"><a>fees</a></b-tooltip> on a recurring basis for example, weekly, fortnightly, monthly or quarterly.
    </h2>
    <div class="columns">
      <div class="column">
        <ongoing-fee v-model="data.ongoingFee" v-on:input="update"/>
      </div>
      <div class="column">
        <div class="select-label">
          <h1 class="is-size-6 has-text-weight-semibold">Over period</h1>
        </div>
        <b-select placeholder="Period" v-model="data.ongoingFeePeriod" v-on:input="update()" expanded>
          <option value="Weekly">
            Weekly
          </option>
          <option value="Fortnightly">
            Fortnightly
          </option>
          <option value="Monthly">
            Monthly
          </option>
        </b-select>
      </div>
    </div>
  </div>
</template>

<script>
import OngoingFee from '../inputs/ongoing-fees/OngoingFee'

export default {
  props: ['value'],
  inject: ['$validator'],
  components: {
    OngoingFee
  },
  data() {
    return {
      data: {
        ongoingFee: this.value.ongoingFee,
        ongoingFeePeriod: this.value.ongoingFeePeriod
      }
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.data)
    }
  }
}
</script>

<style scoped>
.mqu-title {
  font-family: 'National-Extrabold';
}

.mqu-subtitle {
  font-family: 'National-Light';
}

.select-label {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/stages/OngoingFees.vue